import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React, { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import classnames from 'classnames';
import { FilterDecoratorContainer, FiltersContainer, HIDDEN_FILTER, INTER_FILTER_SPACE, LAST_FILTER_NO_COUNT_SPACE, LAST_FILTER_NO_COUNT_CLASS, LAST_FILTER_COUNT_SPACE, LAST_FILTER_COUNT_CLASS, MoreIcon, ROOT_PREFIX, StyledMobileFilterDecoratorContainer, StyledFilterButton, StyledBadge } from './filtersDecoratorStyles';
import { EmbersDateSelect } from '../../../../date';
import { useWindowSize } from '../../../../utils/resizeHook';
import { onKeyPress } from '../../../../utils/wcagUtils';
import { FiltersModal } from './filtersModal';
import { getDateOption, getOption, cloneFilters } from './utils';
var initialMoreIconPosition = {
  visible: false,
  x: 0
};
export var FiltersDecorator = function FiltersDecorator(_ref) {
  var children = _ref.children,
    onSave = _ref.onSave,
    onCancel = _ref.onCancel,
    _ref$codeKey = _ref.codeKey,
    codeKey = _ref$codeKey === void 0 ? 'code' : _ref$codeKey,
    _ref$labelKey = _ref.labelKey,
    labelKey = _ref$labelKey === void 0 ? 'label' : _ref$labelKey,
    reCalculateNeeded = _ref.reCalculateNeeded,
    className = _ref.className,
    dateFormatString = _ref.dateFormatString,
    isMobile = _ref.isMobile,
    filterItems = _ref.filterItems,
    onFilterChange = _ref.onFilterChange;
  var intl = useIntl();
  var filterContainerRef = useRef(null);
  var _useState = useState(initialMoreIconPosition),
    _useState2 = _slicedToArray(_useState, 2),
    moreIconPosition = _useState2[0],
    setMoreIconPosition = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    recalcMoreIconPosition = _useState4[0],
    setRecalcMoreIconPosition = _useState4[1];
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    modalVisible = _React$useState2[0],
    setModalVisible = _React$useState2[1];
  var windowSize = useWindowSize();
  var calculateFiltersAndMoreIconPosition = function calculateFiltersAndMoreIconPosition() {
    if (!filterContainerRef.current || filterContainerRef.current.clientWidth === 0) {
      return;
    }
    var filterEleMap = filterContainerRef.current.querySelectorAll(':scope .EmbersMiniSelectLaunchButton-root');
    if (filterEleMap.length < 2) {
      if (moreIconPosition.x !== initialMoreIconPosition.x || moreIconPosition.visible) {
        setMoreIconPosition(initialMoreIconPosition);
      }
    } else {
      var moreIconLeft = 0;
      var prevElemRight = 0;
      // we might need room for the moreIcon to appear, also possibly the countIcon
      // the moreIcon is 24 pixels wide
      var MORE_ICON_SPACE = 24;
      var availableWidth = filterContainerRef.current.offsetWidth - MORE_ICON_SPACE;
      // 1. calc last show filter index
      var lastShowEleIndex = -1;
      for (var i = 0; i < filterEleMap.length; i++) {
        var countIcon = filterEleMap[i].querySelector('[class*="icon-number"]');
        // if filter have count icon, the spacing is 0 pixel width
        // if filter haven't count icon, the spacing is 24 pixels width
        var elemSpacing = countIcon ? LAST_FILTER_COUNT_SPACE : LAST_FILTER_NO_COUNT_SPACE;
        var lastElemWidth = filterEleMap[i].offsetWidth + elemSpacing;
        var lastElemRight = prevElemRight + lastElemWidth;
        // as last show filter, calc overflowed
        var overflowed = lastElemRight > availableWidth;
        if (!overflowed) {
          lastShowEleIndex = i;
          moreIconLeft = lastElemRight;

          // as prev show filter, save elemRight
          var elemWidth = filterEleMap[i].offsetWidth + INTER_FILTER_SPACE;
          var elemRight = prevElemRight + elemWidth;
          prevElemRight = elemRight;
        } else {
          break;
        }
      }
      if (lastShowEleIndex < filterEleMap.length - 1) {
        // 2. add class
        for (var _i = 0; _i < filterEleMap.length; _i++) {
          filterEleMap[_i].classList.remove(HIDDEN_FILTER);
          filterEleMap[_i].classList.remove(LAST_FILTER_COUNT_CLASS);
          filterEleMap[_i].classList.remove(LAST_FILTER_NO_COUNT_CLASS);
          if (_i > lastShowEleIndex) {
            filterEleMap[_i].classList.add(HIDDEN_FILTER);
          }
          if (_i === lastShowEleIndex) {
            var _countIcon = filterEleMap[_i].querySelector('[class*="icon-number"]');
            var lastShowElemClass = _countIcon ? LAST_FILTER_COUNT_CLASS : LAST_FILTER_NO_COUNT_CLASS;
            filterEleMap[_i].classList.add(lastShowElemClass);
          }
        }
      } else {
        moreIconLeft = 0;
        for (var _i2 = 0; _i2 < filterEleMap.length; _i2++) {
          filterEleMap[_i2].classList.remove(HIDDEN_FILTER);
          filterEleMap[_i2].classList.remove(LAST_FILTER_COUNT_CLASS);
          filterEleMap[_i2].classList.remove(LAST_FILTER_NO_COUNT_CLASS);
        }
      }
      if (moreIconLeft === 0) {
        // hide more icon
        if (moreIconPosition.x !== initialMoreIconPosition.x || moreIconPosition.visible) {
          setMoreIconPosition(initialMoreIconPosition);
        }
      } else {
        // this test is because the newly-created moreIconPosition object will always look
        //  different to useState()'s test, and cause extra renders
        if (moreIconPosition.x !== moreIconLeft || !moreIconPosition.visible) {
          setMoreIconPosition({
            visible: true,
            x: moreIconLeft
          });
        }
      }
    }
    setRecalcMoreIconPosition(false);
  };
  useEffect(function () {
    calculateFiltersAndMoreIconPosition();
  }, [recalcMoreIconPosition, reCalculateNeeded]);
  useEffect(function () {
    calculateFiltersAndMoreIconPosition();
  }, []);
  useEffect(function () {
    calculateFiltersAndMoreIconPosition();
  }, [children]);

  // if the number of filter items changes the MiniSelects may change
  //  their width because of gaining a "count" icon inside themselves
  //  so recalc just to be sure
  useEffect(function () {
    // calling with a timeout because if the change happened because of
    //  clearAll or removing a tag, we need to wait until the filters add
    //  or remove their countIcon
    setTimeout(function () {
      calculateFiltersAndMoreIconPosition();
    }, 100);
  }, [filterItems.length]);
  useEffect(function () {
    setTimeout(function () {
      calculateFiltersAndMoreIconPosition();
    }, 20);
  }, [windowSize]);
  var toggleModal = function toggleModal() {
    modalVisible && (onCancel === null || onCancel === void 0 ? void 0 : onCancel());
    setModalVisible(!modalVisible);
  };
  var handleMoreIconKeyDown = function handleMoreIconKeyDown(e) {
    onKeyPress(e, [' ', 'Enter'], function (e) {
      e.stopPropagation();
      toggleModal();
    });
  };
  var handleSave = function handleSave(newFilterValue, newFilterItems) {
    onSave(newFilterValue, newFilterItems);
    toggleModal();
    setRecalcMoreIconPosition(true);
  };
  var getChildProps = function getChildProps(child, type) {
    var _child$props = child.props,
      name = _child$props.name,
      onChangeOriginal = _child$props.onChange,
      onPickRangeOriginal = _child$props.onPickRange;
    if (name) {
      var childProps;
      if (child.type === EmbersDateSelect) {
        childProps = {
          onPickRange: function onPickRange(range, selection) {
            var _selection$option;
            var option = _objectSpread(_objectSpread({}, getDateOption(range, codeKey, labelKey, dateFormatString)), {}, {
              filterName: name
            });
            onPickRangeOriginal(range, selection);
            onFilterChange({
              filterName: name,
              value: {
                value: selection === null || selection === void 0 ? void 0 : selection.value,
                selection: selection === null || selection === void 0 ? void 0 : selection.option,
                type: type,
                range: range
              },
              reason: selection !== null && selection !== void 0 && (_selection$option = selection.option) !== null && _selection$option !== void 0 && _selection$option.value ? 'selectOption' : 'removeOption',
              option: option,
              multiple: false,
              isDate: true
            });
          }
        };
      } else {
        childProps = {
          onChange: function onChange(value, reason, option) {
            onChangeOriginal(value, reason, option);
            onFilterChange({
              filterName: name,
              value: value,
              reason: reason,
              option: _objectSpread(_objectSpread({}, getOption(option, codeKey, labelKey)), {}, {
                filterName: name
              }),
              multiple: type === 'multiple',
              isDate: false
            });
          }
        };
      }
      return childProps;
    }
    return {};
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, isMobile ? /*#__PURE__*/React.createElement(StyledMobileFilterDecoratorContainer, {
    className: classnames("".concat(ROOT_PREFIX, "-root"), className)
  }, /*#__PURE__*/React.createElement(StyledFilterButton, {
    disableRipple: true,
    className: classnames('EmbersMobileFilterDecorator-filter', {
      'EmbersMobileFilterDecorator-filter-hasCount': filterItems.length > 0
    }),
    onClick: toggleModal
  }, /*#__PURE__*/React.createElement(StyledBadge, {
    color: "secondary",
    badgeContent: filterItems.length
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon-filter"
  })))) : /*#__PURE__*/React.createElement(FilterDecoratorContainer, {
    className: classnames("".concat(ROOT_PREFIX, "-root"), className)
  }, /*#__PURE__*/React.createElement(FiltersContainer, {
    ref: filterContainerRef,
    className: "".concat(ROOT_PREFIX, "-container")
  }, children && cloneFilters(children, getChildProps), moreIconPosition.visible && /*#__PURE__*/React.createElement(MoreIcon, {
    styled: moreIconPosition,
    onClick: toggleModal,
    onKeyDown: handleMoreIconKeyDown,
    className: "icon-more-horizontal-alt",
    tabIndex: 0,
    role: "button",
    "aria-label": intl.formatMessage({
      id: 'embers.table.iconLabel.moreFilters',
      defaultMessage: 'More filters'
    })
  }))), modalVisible && /*#__PURE__*/React.createElement(FiltersModal, {
    defaultFilterItems: filterItems,
    onClose: toggleModal,
    onSave: handleSave,
    onFilterChange: onFilterChange,
    isMobile: isMobile,
    codeKey: codeKey,
    labelKey: labelKey,
    dateFormatString: dateFormatString
  }, children));
};